import { type Module } from "vuex";
import type { DefaultApi, UserInvitationRequest } from "@/api";
import { UserInvitation } from "@/models/user_invitation";
import { UserInvitations } from "@/models/user_invitations";
import type { State as RootState } from "@/stores";
export interface State {
  userInvitations?: UserInvitations;
}
export const module: Module<State, RootState> = {
  namespaced: true,
  state: {
    userInvitations: [],
  },
  actions: {
    async getOrganizationInvitations({ commit }) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.getOrganizationInvitations();
      const invitations = new UserInvitations(
        response.data.map((invitation) => new UserInvitation(invitation)),
      );
      commit("setUserInvitations", invitations);
      return invitations;
    },
    async postOrganizationInvitation({}, invitation: UserInvitationRequest) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.postOrganizationInvitation(invitation);
      return response.data;
    },
    async deleteOrganizationInvitation({}, invitationId: string) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.deleteOrganizationInvitation(invitationId);
      return response.data;
    },
  },
  mutations: {
    setUserInvitations(state, userInvitations: UserInvitations) {
      state.userInvitations = userInvitations;
    },
  },
};
